import { type T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import type { IkePageName } from '../../page/page';
import { Services } from '../../services';
import type { RouteParams } from '../../services/route.service';
import { Icon } from '../icon';
import type { MaterialIcon, MaterialSymbol } from '../icon/icons';
import { CSS, MDL } from './image.button.style';

export { CSS } from './image.button.style';

export interface ImageButtonCtx {
	type?: 'button' | 'a';
	className?: string;
	id?: string;
	disabled?: boolean;
	title?: T | string;
	titleAttrs?: any;
	href?: IkePageName;
	hrefParams?: RouteParams;
	flip?: boolean;
	onclick?: (a: MouseEvent) => void;
	testId?: string;
}

function iconClassName(ctx: ImageButtonCtx): string {
	return CSS.icon + ' ' + (ctx.flip ? CSS.flip : '');
}

function render(iconNode: MithrilVNode, ctx: ImageButtonCtx) {
	const href = ctx.href ? Services.Route.getRouteURL(ctx.href, ctx.hrefParams) : undefined;
	const extraClassName = ctx.className != null ? ctx.className : '';
	const title = ctx.title != null ? Translate(ctx.title, ctx.titleAttrs) : '';

	return m(
		ctx.type || 'a',
		{
			className: `${MDL.container} ${CSS.container} ${extraClassName != null ? extraClassName : ''}`,
			id: ctx.id,
			'data-testid': ctx.testId,
			...(ctx.disabled && { disabled: ctx.disabled }),
			title,
			href,
			onclick: ctx.disabled ? undefined : ctx.onclick,
		},
		iconNode
	);
}

export function view(icon: MaterialIcon | MithrilVNode, ctx: ImageButtonCtx = {}) {
	const isMaterialIcon = typeof icon === 'string';
	return render(isMaterialIcon ? Icon.view(icon, { className: iconClassName(ctx) }) : icon, ctx);
}

/**
 * Material Symbols ligatures need the Symbols font, and both enums are plain strings — so the icon can't
 * be told apart at runtime and symbol buttons need their own entry point.
 */
export function viewSymbol(symbol: MaterialSymbol, ctx: ImageButtonCtx = {}) {
	return render(Icon.symbol(symbol, { className: iconClassName(ctx) }), ctx);
}

export const ImageButton = { view, viewSymbol, CSS };
